import HttpGlobal from "../Global/HttpGlobal.class";

export type InterestProductT = "health";

export interface ProductInterestI {
  product: InterestProductT;
  registered: boolean;
  registeredAt: string | null;
}

/**
 * "Avisarme cuando esté disponible" del dashboard. El backend guarda el interés
 * (idempotente por lead + producto) y publica `ProductInterestRegistered`, que
 * el CRM interno consume para la ficha y la lista de la campaña.
 */
export default class HttpProductInterestRepository extends HttpGlobal {
  private readonly API_URL_PRODUCT_INTEREST:
    | string
    | undefined = `${process.env.REACT_APP_CUSTOMER_APP_URL}api/dashboard/product-interest`;

  get = async (product: InterestProductT): Promise<ProductInterestI> => {
    const response: ProductInterestI = await this.generalGet(
      `${this.API_URL_PRODUCT_INTEREST}/${this.leadId}/${product}`
    );
    return response;
  };

  register = async (product: InterestProductT): Promise<ProductInterestI> => {
    const response: ProductInterestI = await this.generalPost({
      url: `${this.API_URL_PRODUCT_INTEREST}/${this.leadId}/${product}`,
      dataRequest: {},
    });
    return response;
  };
}
